export type TaskStatusBadgeKey =
  | 'DONE'
  | 'CANCELLED'
  | 'OVERDUE'
  | 'AUTO_DONE'
  | 'SKIPPED';

export const TASK_STATUS_BADGE_CONFIG: Record<
  TaskStatusBadgeKey,
  { color: string; label: string }
> = {
  DONE: { color: 'green', label: 'Выполнено' },
  CANCELLED: { color: 'orange', label: 'Отменено' },
  OVERDUE: { color: 'red', label: 'Просрочено' },
  AUTO_DONE: { color: 'cyan', label: 'Автоматически выполнено' },
  SKIPPED: { color: 'default', label: 'Пропущено' }
};
